export function removeExtension(req, res) {
    const pathname = req.url.pathname;
    const pattern = /\.htm(l?)$/g;
    if (pathname.match(pattern)) {
        const newPathname = pathname.replace(pattern, '');
        return res.redirect(newPathname, 301);
    }
}
